<template>
  <div>
    <Topbar title="Bienvenue" backButton />
    <section class="Section PasswordConfirmation">
      <form @submit.prevent="reset" autocomplete="off">
        <div class="PasswordConfirmation__text" v-if="isConfirmation">
          Nous sommes très heureux de vous accueillir sur CaptainVin !<br /><br />
          Pour finaliser votre inscription nous avons besoin que vous choisissiez un mot de passe.
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Création d’un mot de passe</label>
          <PasswordInput :required="true" v-model="password" />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Validation du mot de passe (vérification)</label>
          <PasswordInput :required="true" v-model="passwordConfirmation" />
        </div>
        <template v-if="isConfirmation">
          <SwitchInput id="cgu" v-model="cgu">
            <div>En m’inscrivant, j’accepte les <a href="./#/cgu-cgv" class="PasswordConfirmation__cgu" target="_blank">CGU</a></div>
          </SwitchInput>
          <SwitchInput v-if="!isProfessional" id="majority" label="Je confirme être majeur" v-model="majority" />
          <SwitchInput id="newsletter" :readonly="loading" label="Recevoir les offres chaque semaine" v-model="newsletter" />
        </template>
        <div class="PasswordConfirmation__actions">
          <Button class="Button--primary" type="submit" :loading="loading">Confirmation</Button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import notificationService from "../services/notification";
import PasswordInput from "../components/PasswordInput";
import Button from "../components/Button";
import SwitchInput from "../components/SwitchInput";

export default {
  data() {
    return {
      password: "",
      passwordConfirmation: "",
      cgu: false,
      majority: false,
      loading: false,
      newsletter: true
    };
  },
  computed: {
    isConfirmation() {
      return typeof this.$route.query.client_type !== "undefined";
    },
    isProfessional() {
      return this.$route.query.client_type === "pro";
    },
    isValid() {
      return this.isPasswordsValid && this.isCGUValid && this.isMajorityValid;
    },
    isPasswordsValid() {
      return this.password !== ""
        && this.passwordConfirmation !== ""
        && this.passwordConfirmation === this.password;
    },
    isCGUValid() {
      return !this.isConfirmation || this.cgu;
    },

    isMajorityValid() {
      return !this.isConfirmation || this.isProfessional || this.majority;
    }
  },
  methods: {
    reset: function() {
      if (!this.isValid) {
        if (!this.isMajorityValid) {
          notificationService.error("Vous devez être majeur pour accéder à Captain Vin.");
        }

        if (!this.isCGUValid) {
          notificationService.error("Merci d'accepter les CGU, pour finaliser votre inscription.");
        }

        if (!this.isPasswordsValid) {
          notificationService.error("Vous n'avez pas saisi les mêmes mots de passe.");
        }

        return;
      }

      this.loading = true;

      this.$store.dispatch("auth/confirmPassword", {
        password: this.password,
        passwordConfirmation: this.passwordConfirmation,
        token: this.$route.params.token,
        ...this.isConfirmation && { cgu: this.cgu, newsletter: this.newsletter }
      })
        .then(() => {
          this.$router.replace("/");
          notificationService.success("Votre modification a été prise en compte.");
        })
        .catch(err => notificationService.error(err.message, err.errors))
        .then(() => this.loading = false);
    }
  },
  components: {
    PasswordInput,
    Button,
    SwitchInput
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/_variables.scss';

  .PasswordConfirmation {
    max-width: 32rem;

    &__text {
      line-height: 1.5;
      margin-bottom: $global-margin * 2;
    }

    &__cgu {
      color: $color-primary;
      text-decoration: underline;
    }

    &__actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
</style>
